import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useUIDSeed } from 'react-uid'

import style from './Manage.style'
import ManageStatisticsItem from './ManageStatisticsItem'
import ManageItem from './ManageItem'

const ManageStyled = styled.div(props => ({ ...style(props) }))

const Manage = ({ title, titleTag: TitleTag, service, statistics, text, icon }) => {
    const uid = useUIDSeed()
    return (
        <ManageStyled>
            <div className="ManageContainer">
                <div className="Content">
                    <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title }} />
                    {/* eslint-disable react/no-danger */}
                    {text && <div className="Text" dangerouslySetInnerHTML={{ __html: text }} />}
                    <ul className="Statistics">
                        {statistics.map(item => (
                            <li key={uid(item)}>
                                <ManageStatisticsItem number={item.number} text={item.text} />
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="ManageGrid">
                    <ul>
                        {service.map(item => (
                            <li key={uid(item)}>
                                <ManageItem text={item.text} icon={item.icon} scrollTo={item.scrollTo} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </ManageStyled>
    )
}

Manage.propTypes = {
    title: PropTypes.string.isRequired,
    titleTag: PropTypes.string,
    text: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    statistics: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
            text: PropTypes.string
        })
    ),
    service: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
            text: PropTypes.string
        })
    )
}

Manage.defaultProps = {
    titleTag: 'p',
    icon: undefined,
    statistics: [],
    service: []
}

export default withTheme(Manage)
